const STORAGE_KEY = 'ofrontend.businessClientWorkerIdentifier';

function safeGet(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

function safeSet(value: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
}

function safeRemove(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Persist the worker-registration code for the signed-in business client account. */
export function persistBusinessClientWorkerIdentifier(identifier: string): void {
  const normalized = identifier.trim();
  if (!/^\d{8}$/.test(normalized)) {
    return;
  }
  safeSet(normalized);
}

export function getStoredBusinessClientWorkerIdentifier(): string | null {
  const value = safeGet();
  return value && /^\d{8}$/.test(value) ? value : null;
}

export function clearStoredBusinessClientWorkerIdentifier(): void {
  safeRemove();
}
